<template>
  <div class="position-relative">
    <div v-if="input_groups.groups.length > 1" class="">
      <h3 for="logic_between_groups">Logic between groups:</h3>
      <!-- <input v-model="logicBetweenGroups" type="text" id="logic_between_groups" /> -->
      <b-form-select
        v-model="input_groups.logic_between_groups"
        :options="logicOptions"
        @change="handlelogicBetweenGroupsChange"
      >
      </b-form-select>
    </div>
    <div
      v-for="(group, index) in input_groups.groups"
      :key="index"
      class="group-container"
    >
      <div class="group position-relative">
        <div @click="removeGroup(index)" class="remove-button mx-3">
          <i class="fas fa-times"></i>
        </div>
        <h3 for="logic_between_sub_groups">Logic between conditions:</h3>
        <b-form-select
          v-model="group.logic_between_sub_groups"
          :options="logicOptions"
        ></b-form-select>

        <!-- <input v-model="group.logicBetweenSubGroups" type="text" id="logic_between_sub_groups" /> -->

        <!-- <dynamic-form v-if="group.groups.length > 0" :groups="group.groups" /> -->

        <!-- <label for="logic_between_conditions">Logic between conditions:</label>
        <input
          v-model="group.logicBetweenConditions"
          type="text"
          id="logic_between_conditions"
        />
        <b-form-select
          v-model="group.logicBetweenConditions"
          :options="logicOptions"
        ></b-form-select> -->

        <div
          v-for="(condition, conditionIndex) in group.sub_groups"
          :key="conditionIndex"
          class="condition border position-relative px-3 pt-3"
        >
          <div
            @click="removeGroupCondition(index, conditionIndex)"
            class="remove-button mx-3"
          >
            <i class="fas fa-times"></i>
          </div>
          <h3 for="field">Field:</h3>
          <b-form-select
            class="mb-3"
            :value="findFieldItem(index, conditionIndex)"
            :options="fieldOptions"
            @change="
              (val) => {
                if (
                  !input_groups.groups[index].sub_groups[conditionIndex] ||
                  !input_groups.groups[index].sub_groups[conditionIndex]
                    .conditions ||
                  !input_groups.groups[index].sub_groups[conditionIndex]
                    .conditions[0] ||
                  val.conditions[0].field !=
                    input_groups.groups[index].sub_groups[conditionIndex]
                      .conditions[0].field
                ) {
                  onFieldChanged(val, index, conditionIndex);
                }
              }
            "
          ></b-form-select>
          <QuestionCondition
            :forms="forms"
            v-if="
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions &&
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions[0] &&
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions[0].field == 'form'
            "
            :conditions.sync="
              input_groups.groups[index].sub_groups[conditionIndex]
            "
            :onChange="
              (conditions) => {
                input_groups.groups[index].sub_groups[conditionIndex] =
                  conditions;
                $emit('update:groups', input_groups);
              }
            "
          />

          <TicketCondition
            :tickets="tickets"
            v-else-if="
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions &&
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions[0] &&
              input_groups.groups[index].sub_groups[conditionIndex]
                .conditions[0].field == 'ticket_type'
            "
            :conditions.sync="
              input_groups.groups[index].sub_groups[conditionIndex]
            "
            :onChange="
              (conditions) => {
                input_groups.groups[index].sub_groups[conditionIndex] =
                  conditions;
                $emit('update:groups', input_groups);
              }
            "
          />
          <!--
          <label for="operator">Operator:</label>
          <input v-model="condition.operator" type="text" id="operator" />

          <label for="value">Value:</label>
          <input v-model="condition.value" type="text" id="value" /> -->
        </div>
        <vs-button
          class="add-option-button ml-0 px-2 mt-3"
          type="flat"
          @click="addCondition(index)"
          >Add Condition
        </vs-button>
      </div>
    </div>

    <!-- Add Group button at the global level -->
    <vs-button
      class="add-option-button ml-0 px-2 mt-3"
      type="flat"
      @click="addGlobalGroup()"
      >Add Conditions Group
    </vs-button>
    <!-- <button @click="addGlobalGroup">Add Group at Global Level</button> -->
  </div>
</template>

<script>
import QuestionCondition from "./QuestionCondition.vue";
import TicketCondition from "./TicketCondition.vue";
export default {
  components: {
    QuestionCondition,
    TicketCondition
  },
  props: {
    groups: {
      type: Object,
      default: () => {
        return {
          logic_between_groups: "AND",
          groups: [],
        };
      },
    },
    forms: {
      type: Array,
      default: () => [],
    },
    tickets: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    groups() {
      this.input_groups = this.groups;
    },
  },
  data() {
    return {
      input_groups: this.groups,
      replica_input_groups: this.groups,
      // logicBetweenGroups: this.groups.logic_between_groups || "AND",
      logicOptions: ["AND", "OR"],
      fieldOptions: [
        {
          text: "Question",
          value: {
            logic_between_conditions: "AND",
            conditions: [
              {
                field: "form",
                operator: "=",
                value: "",
              },
              {
                field: "question",
                operator: "=",
                value: "",
              },
              {
                field: "answer",
                operator: "=",
                value: "",
              },
            ],
          },
        },
        {
          text: "Selected Ticket",
          value: {
            logic_between_conditions: "AND",
            conditions: [
              {
                field: "ticket_type",
                operator: "=",
                value: "",
              },
            ],
          },
        },
      ],
    };
  },
  methods: {
    findFieldItem(index, conditionIndex) {
      if (
        !this.input_groups.groups[index].sub_groups[conditionIndex] ||
        !this.input_groups.groups[index].sub_groups[conditionIndex]
          .conditions ||
        !this.input_groups.groups[index].sub_groups[conditionIndex]
          .conditions[0]
      ) {
        return "";
      }
      return (
        this.fieldOptions.find(
          (item) =>
            item.value.conditions[0].field ==
            this.input_groups.groups[index].sub_groups[conditionIndex]
              .conditions[0].field
        ) || {}
      ).value;
    },
    handlelogicBetweenGroupsChange() {
      this.$emit("update:groups", this.input_groups);
    },
    addCondition(parentIndex) {
      this.input_groups.groups[parentIndex].sub_groups.push({
        logic_between_conditions: "AND",
        conditions: [],
      });
      // this.replica_input_groups.groups[parentIndex].sub_groups.push({
      //   field: "",
      // });
      this.$emit("update:groups", this.input_groups);
    },
    addGlobalGroup() {
      this.input_groups.groups.push({
        logic_between_sub_groups: "AND",
        sub_groups: [],
      });
      // this.replica_input_groups.groups.push({
      //   logic_between_sub_groups: "AND",
      //   sub_groups: [],
      // });
      this.$emit("update:groups", this.input_groups);
    },
    removeGroup(index) {
      this.input_groups.groups.splice(index, 1);
      // this.replica_input_groups.groups.splice(index, 1);
      this.$emit("update:groups", this.input_groups);
    },
    removeGroupCondition(groupindex, conditionindex) {
      this.input_groups.groups[groupindex].sub_groups.splice(conditionindex, 1);
      // this.replica_input_groups.groups[groupindex].sub_groups.splice(
      //   conditionindex,
      //   1
      // );
      this.$emit("update:groups", this.input_groups);
    },
    onFieldChanged(val, index, conditionIndex) {
      this.input_groups.groups[index].sub_groups[conditionIndex].conditions =
        val.conditions;
      this.$emit("update:groups", this.input_groups);
    },
  },
};
</script>

<style scoped>
.remove-button {
  position: absolute;
  right: 0;
  top: 0;
  color: #e40813;
  font-size: 2rem;
  cursor: pointer;
}
</style>
<style>
.group-container {
  margin-top: 20px;
}

.group {
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
}

.condition {
  margin-top: 10px;
}
</style>
